"use client";

import { Feed } from "@/components/feed/feed";
import { PublicLandingPage } from "@/components/landing/public-landing-page";
import { useCurrentUser } from "@/hooks/use-current-user";
import { useNativeApp } from "@/hooks/use-native-app";

export function HomeRoute() {
  const currentUserQuery = useCurrentUser();
  const isNative = useNativeApp();

  if (currentUserQuery.data) {
    return <Feed />;
  }

  if (currentUserQuery.isLoading || isNative) {
    return <div className="min-h-screen bg-white" />;
  }

  return <PublicLandingPage />;
}
